import type { IconData } from '@stacksjs/iconify-core'

export const heart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.636 7.208L10 13.572l6.364-6.364a3 3 0 1 0-4.243-4.243L10 5.086l-2.121-2.12a3 3 0 0 0-4.243 4.242M9.293 1.55l.707.707l.707-.707a5 5 0 1 1 7.071 7.071l-7.07 7.071a1 1 0 0 1-1.415 0l-7.071-7.07a5 5 0 1 1 7.07-7.071z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default heart
